import { Pipe, PipeTransform } from '@angular/core';

import { Column } from '../../../interfaces';

@Pipe({
  name: 'checkUnderline',
  standalone: true,
})
export class CheckUnderlinePipe implements PipeTransform {
  /**
   * Verificar se existe sublinha na célula
   * @param row Dados da linha
   * @param column Dados da coluna
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(row: any, column?: Column): boolean {
    if (!column || !column?.subline) {
      return false;
    }

    if (typeof column.subline === 'string') {
      // subline é o nome de uma propriedade do objeto
      const value = row?.[column.subline];
      return value != null && value !== '';
    }

    if (Array.isArray(column.subline)) {
      return column.subline.some((sub) => row?.[sub.name] != null);
    }

    if (column.subline && typeof column.subline === 'object') {
      // subline é uma coluna (Column)
      return row?.[column.subline.name] != null;
    }

    return false;
  }
}
